<template>
  <div>
    <HeaderProduct
      buttonTitle="Editar"
      buttonTitle2="Excluir"
      :haveCustomButton="isDetail"
      :title="
        isDetail ? 'Produtos | Detalhar' : 'Produtos | Cadastro de produtos'
      "
      :text="
        isDetail ? '' : 'Cadastre um novo produto, insira suas informações.'
      "
      @voltar="
        isDetail ? $router.push('/products') : (confirmExitDialog = true)
      "
      @action2="isDetail = false"
      @action3="deleteProduct()"
      :haveAction="false"
      :haveBack="true"
    />

    <v-file-input
      :disabled="isDetail"
      id="imageInput"
      accept="image/png, image/jpeg"
      style="display: none"
      @change="setImages"
      multiple
    ></v-file-input>

    <v-container style="max-width: unset">
      <v-card class="main-card mx-auto pa-6" max-width="1328px">
        <v-form ref="form" v-model="firstValid" :key="clear">
          <v-row class="ma-0">
            <v-col cols="12" sm="7" md="7" lg="7">
              <span class="ml-1 mb-2 label-details">Nome do produto:</span>
              <v-text-field
                :disabled="isDetail"
                outlined
                class="px-0"
                v-model="currentProduct.productName"
                style="
                  border: 1px solid #979797;
                  border-radius: 7.5px;
                  height: 58px !important;
                "
                color="black"
                background-color="#F5F5F5"
                :rules="[rules.nameRules]"
                @keyup="skuDefault($event.target.value)"
                placeholder="Nome do Produto"
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="5" md="5" lg="5">
              <span class="ml-1 mb-2 label-details">Código:</span>
              <v-text-field
                :disabled="isDetail"
                outlined
                v-model="currentProduct.productCode"
                style="
                  border: 1px solid #979797;
                  border-radius: 7.5px;
                  height: 58px !important;
                "
                color="black"
                background-color="#F5F5F5"
                :rules="[rules.required]"
                type="number"
                placeholder="00000000000"
                required
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="7" md="7" lg="7">
              <span class="ml-1 mb-2 label-details">SKU:</span>
              <v-text-field
                :disabled="isDetail"
                v-model="currentProduct.productSku"
                outlined
                style="
                  border: 1px solid #979797;
                  border-radius: 7.5px;
                  height: 58px !important;
                "
                color="black"
                background-color="#F5F5F5"
                :rules="[rules.nameRules]"
                required
                :key="componentKey"
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="6" md="2" lg="2">
              <span class="ml-1 mb-2 label-details">EAN:</span>
              <v-text-field
                :disabled="isDetail"
                outlined
                class="px-0"
                v-model="currentProduct.productEAN"
                style="border: 1px solid #979797; border-radius: 7.5px"
                color="black"
                background-color="#F5F5F5"
                hide-details
                :rules="[rules.required]"
                placeholder="00000000000"
                type="number"
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="6" md="2" lg="2">
              <div>
                <span class="ml-1 mb-2 label-details">Calculadora:</span>
                <v-select
                  :disabled="isDetail"
                  :items="statusCalculator"
                  item-text="label"
                  item-value="value"
                  outlined
                  hide-details
                  v-model="currentProduct.calculator"
                  required
                  style="border: 1px solid #979797; border-radius: 7.5px"
                  color="black"
                  background-color="#F5F5F5"
                >
                </v-select>
              </div>
            </v-col>
          </v-row>

          <v-row class="ma-0">
            <v-col cols="12" sm="7" md="5" lg="5">
              <span class="ml-1 mb-2 label-details">Categoria:</span>
              <v-select
                :rules="[(v) => v.length != 0 || 'Campo obrigatório']"
                :disabled="isDetail"
                return-object
                outlined
                :search-input.sync="searchCategoryInput"
                @change="(searchCategoryInput = ''), listSubCategorias()"
                v-model="currentProduct.productCategories"
                style="border-radius: 7.5px; font-weight: normal !important"
                append-icon="mdi-chevron-down"
                placeholder="Selecionar"
                hide-details
                clearable
                color="white"
                background-color="normalred"
                dark
                :items="productCategories"
                item-text="categoryName"
                item-value="categoryId"
                multiple
              >
                <template v-slot:selection="{ attrs, item, select, selected }">
                  <v-chip
                    v-bind="attrs"
                    :input-value="selected"
                    close
                    @click="select"
                    @click:close="
                      remove(item, currentProduct.productCategories, true)
                    "
                  >
                    <strong>{{ item.categoryName }}</strong>
                  </v-chip>
                </template>
              </v-select>
            </v-col>

            <v-col cols="12" sm="5" md="2" lg="2" class="d-flex align-center">
              <v-btn
                :disabled="isDetail"
                class="mt-5 mx-auto"
                style="border-radius: 7.5px"
                color="normalred"
                height="56"
                elevation="0"
                @click="
                  dialogKey = !dialogKey;
                  newCategoryDialog = true;
                "
              >
                <v-icon small class="ma-0 pa-0">mdi-plus</v-icon>
                Categoria
              </v-btn>
            </v-col>

            <v-col cols="12" sm="5" md="5" lg="5">
              <span class="ml-1 mb-2 label-details">SubCategoria:</span>
              <v-select
                :disabled="isDetail"
                return-object
                outlined
                :search-input.sync="searchSubCategoryInput"
                @change="searchSubCategoryInput = ''"
                v-model="currentProduct.productSubCategories"
                style="border-radius: 7.5px; font-weight: normal !important"
                append-icon="mdi-chevron-down"
                placeholder="Selecionar"
                hide-details
                clearable
                color="white"
                background-color="normalred"
                dark
                :items="productSubCategories"
                item-text="subCategory.name"
                item-value="subCategory.subCategoryId"
                multiple
              >
                <template v-slot:selection="{ attrs, item, select, selected }">
                  <v-chip
                    v-bind="attrs"
                    :input-value="selected"
                    close
                    @click="select"
                    @click:close="
                      remove(item, currentProduct.productSubCategories)
                    "
                  >
                    <strong>{{ item.subCategory.name }}</strong>
                  </v-chip>
                </template>
              </v-select>
            </v-col>

            <v-col cols="12" sm="5" md="5" lg="5">
              <span class="ml-1 mb-2 label-details">Material:</span>
              <v-text-field
                :disabled="isDetail"
                outlined
                v-model="currentProduct.productApplication"
                style="
                  border: 1px solid #979797;
                  border-radius: 7.5px;
                  height: 58px !important;
                "
                color="black"
                background-color="#F5F5F5"
                :rules="[rules.nameRules]"
                placeholder="Automotivo"
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="6" md="2" lg="2">
              <span class="ml-1 mb-2 label-details">Espessura:</span>
              <v-text-field
                :disabled="isDetail"
                outlined
                v-model="currentProduct.productType"
                style="
                  border: 1px solid #979797;
                  border-radius: 7.5px;
                  height: 58px !important;
                "
                color="black"
                background-color="#F5F5F5"
                :rules="[rules.max32Caracteres]"
                placeholder="Fosco"
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="6" md="2" lg="2">
              <span class="ml-1 mb-2 label-details">Acabamento:</span>
              <v-text-field
                :disabled="isDetail"
                outlined
                :rules="[rules.max64Caracteres]"
                v-model="currentProduct.productGlue"
                required
                style="
                  border: 1px solid #979797;
                  border-radius: 7.5px;
                  height: 58px !important;
                "
                color="black"
                background-color="#F5F5F5"
                placeholder="Aquosa"
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="6" md="3" lg="3">
              <span class="ml-1 mb-2 label-details">Tipo de cola:</span>
              <v-text-field
                :disabled="isDetail"
                outlined
                :rules="[rules.max64Caracteres]"
                v-model="currentProduct.productLiner"
                style="
                  border: 1px solid #979797;
                  border-radius: 7.5px;
                  height: 58px !important;
                "
                color="black"
                background-color="#F5F5F5"
                placeholder="Papel couchê"
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="4" md="3" lg="3">
              <span class="ml-1 mb-2 label-details"
                >Altura do Rolo (1metro):
              </span>
              <v-text-field
                :disabled="isDetail"
                outlined
                :key="auxKey"
                v-model="currentProduct.espessura"
                style="border: 1px solid #979797; border-radius: 7.5px"
                color="black"
                background-color="#F5F5F5"
                hide-details
                placeholder="Automotivo"
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="4" md="3" lg="3">
              <span class="ml-1 mb-2 label-details"
                >Largura do Rolo (1metro):
              </span>
              <v-text-field
                :disabled="isDetail"
                outlined
                :key="auxKey"
                v-model="currentProduct.largura"
                style="border: 1px solid #979797; border-radius: 7.5px"
                color="black"
                background-color="#F5F5F5"
                hide-details
                placeholder="Fosco"
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="4" md="3" lg="3">
              <span class="ml-1 mb-2 label-details"
                >Comprimento do Rolo (1metro):
              </span>
              <v-text-field
                :disabled="isDetail"
                outlined
                :key="auxKey"
                hide-details
                v-model="currentProduct.comprimento"
                required
                style="border: 1px solid #979797; border-radius: 7.5px"
                color="black"
                background-color="#F5F5F5"
                placeholder="Aquosa"
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="4" md="3" lg="3">
              <span class="ml-1 mb-2 label-details">Kg do Rolo (1metro): </span>
              <v-text-field
                :disabled="isDetail"
                outlined
                :key="auxKey"
                hide-details
                v-model="currentProduct.pesoLiquido"
                required
                style="border: 1px solid #979797; border-radius: 7.5px"
                color="black"
                background-color="#F5F5F5"
                placeholder="Aquosa"
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="6" md="6" lg="6">
              <span class="ml-1 mb-2 label-details">Durabilidade:</span>
              <v-textarea
                :disabled="isDetail"
                outlined
                :rules="[rules.required]"
                hide-details
                v-model="currentProduct.productDurability"
                placeholder="Digite a durabilidade em anos"
                style="border: 1px solid #979797; border-radius: 7.5px"
                color="black"
                background-color="#F5F5F5"
              ></v-textarea>
            </v-col>

            <v-col cols="12" sm="6" md="6" lg="6">
              <span class="ml-1 mb-2 label-details">Estoque:</span>
              <v-autocomplete
                :disabled="isDetail"
                :items="status"
                v-model="currentProduct.productInventory"
                :rules="[rules.required]"
                style="border-radius: 7.5px"
                append-icon="mdi-chevron-down"
                hide-details
                clearable
                dark
                color="white"
                placeholder="Selecione o status do produto"
                background-color="normalred"
                item-text="label"
                item-value="value"
                outlined
              ></v-autocomplete>
            </v-col>

            <v-col cols="12" sm="6" md="6" lg="6">
              <span class="ml-1 mb-2 label-details">Descrição:</span>
              <v-textarea
                :disabled="isDetail"
                outlined
                :rules="[(v) => !!v || 'Campo obrigatório', (v) => v.length < 499 || 'Máximo de 500 caracteres']"
                hide-details
                v-model="currentProduct.productDescription"
                placeholder="Descrição detalhada do produto"
                style="border: 1px solid #979797; border-radius: 7.5px;"
                color="black"
                background-color="#F5F5F5"
              ></v-textarea>
            </v-col>

            <v-col cols="12" sm="6" md="6" lg="6">
              <span class="ml-1 mb-2 label-details">Vantagens:</span>
              <v-textarea
                :disabled="isDetail"
                hide-details
                style="
                  border: 1px solid #979797;
                  border-radius: 7.5px;"
                color="black"
                background-color="#F5F5F5"
                outlined
                :rules="[rules.required, rules.nameRules]"
                v-model="currentProduct.productIndicator"
                rows="5"
                placeholder="Escreva cada indicação separando por vírgulas."
              ></v-textarea>
            </v-col>
          </v-row>

          <v-row class="ma-0 my-3">
            <v-col cols="12">
              <span class="photo-field ml-1">
                Fotos
                <strong style="color: #bc0000">*</strong>
              </span>

              <div class="div-images d-flex mt-2">
                <draggable
                    class="list-group"
                    tag="div"
                    ghost-class="ghost"
                    v-model="currentProduct.images"
                    v-bind="dragOptions"
                    @start="drag = true"
                    @end="drag = false"
                >
                  <transition-group type="transition" :name="!drag ? 'flip-list' : null">
                    <div
                        class="list-group-item d-inline-flex align-center"
                        v-for="(image, i) in currentProduct.images"
                        :key="i"
                    >
                      <div class="d-flex flex-column text-center">
                        <v-hover v-slot="{ hover }">
                          <v-img
                              :src="image.path"
                              :style="i === 0 || hover
                                ? 'border: 2px solid #BC0000; border-radius: 5px !important; cursor: pointer'
                                : 'border-radius: 5px !important; opacity: .7; cursor: pointer'"
                              width="150"
                              height="150"
                              :class="hover ? 'elevation-6 mx-2' : 'mx-2'"
                          >
                          </v-img>
                        </v-hover>

                        <span v-if="i === 0" class="main-image-field mt-2">
                          Foto da capa
                        </span>

                        <span v-else class="my-3"> </span>

                        <span class="delete-photo" @click="confirmDeleteImage(image)">
                        Excluir
                      </span>
                      </div>
                    </div>
                  </transition-group>
                </draggable>

                <div class="d-flex flex-column align-center">
                  <v-hover v-slot="{ hover }">
                    <div
                      class="image-container mx-2"
                      :style="hover ? 'border: 2px solid #BC0000' : ''"
                      @click="openPicker"
                    >
                      <v-img
                        src="../../../../assets/plus.svg"
                        contain
                        max-width="37"
                        height="33"
                      >
                      </v-img>
                    </div>
                  </v-hover>

                  <span class="image-field mt-2">Adicionar fotos</span>
                </div>
              </div>
            </v-col>
          </v-row>

          <v-row class="ma-0 my-3">
            <v-col cols="12">
              <span class="photo-field ml-1">
                Vídeos
              </span>

              <div v-if="showVideos" class="div-images d-flex mt-2">
                <draggable
                    class="list-group"
                    tag="div"
                    ghost-class="ghost"
                    v-model="currentProduct.videos"
                    v-bind="dragOptionsVideos"
                    @start="dragVideo = true"
                    @end="dragVideo = false"
                >
                  <transition-group type="transition" :name="!dragVideo? 'flip-list' : null">
                    <div
                        class="list-group-item d-inline-flex align-center"
                        v-for="(video, i) in currentProduct.videos"
                        :id="video.uid"
                        :key="i"
                    >
                      <div class="d-flex flex-column text-center">
                        <v-hover v-slot="{ hover }">
                          <p
                              :key="video.uid"
                              class="image-container"
                              v-html="video.htmlEmbed"
                              :style="i === 0 || hover
                                ? 'border: 2px solid #BC0000; border-radius: 5px !important; cursor: pointer'
                                : 'border-radius: 5px !important; opacity: .7; cursor: pointer; width'"
                              :class="hover ? 'elevation-6 mx-2' : 'mx-2'"
                          >
                          </p>
                        </v-hover>

                        <a class="delete-photo" @click="deleteVideo(video.uid)">
                          Excluir
                        </a>
                      </div>
                    </div>
                  </transition-group>
                </draggable>

                <div class="d-flex flex-column align-center">
                  <v-hover v-slot="{ hover }">
                    <div
                        class="image-container mx-2"
                        :style="hover ? 'border: 2px solid #BC0000' : ''"
                        @click="showModalAddVideos"
                    >
                      <v-img
                          src="../../../../assets/plus.svg"
                          contain
                          max-width="37"
                          height="33"
                      >
                      </v-img>
                    </div>
                  </v-hover>

                  <span class="image-field mt-2">Adicionar vídeo do Yotube</span>
                </div>
              </div>
            </v-col>
          </v-row>

          <v-row class="ma-0">
            <v-col cols="12" sm="6" md="3" lg="2">
              <div>
                <span class="ml-1 mb-2 label-details">Preço por metro:</span>

                <v-text-field
                  :disabled="isDetail"
                  style="border: 1px solid #979797; border-radius: 7.5px"
                  color="black"
                  background-color="#F5F5F5"
                  outlined
                  prefix="R$"
                  :rules="[rules.required]"
                  @keyup="calculateClientPrice()"
                  hide-details
                  :key="auxKeyMetro"
                  v-model="currentProduct.price"
                ></v-text-field>
              </div>
            </v-col>

            <v-col cols="12" sm="6" md="3" lg="2">
              <div>
                <span class="ml-1 mb-2 label-details">IPI(%):</span>
                <v-text-field
                  :disabled="isDetail"
                  maxlength="5"
                  oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                  style="border: 1px solid #979797; border-radius: 7.5px"
                  color="black"
                  type="number"
                  background-color="#F5F5F5"
                  outlined
                  @keyup="calculateClientPrice()"
                  @click="calculateClientPrice()"
                  placeholder="0.00%"
                  hide-details
                  v-model="currentProduct.ipi"
                ></v-text-field>
              </div>
            </v-col>

            <v-col cols="12" sm="6" md="4" lg="3">
              <span class="ml-1 mb-2 label-details">Preço para revenda:</span>

              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon class="pa-0" color="#DADADA" v-bind="attrs" v-on="on">
                    mdi-information-outline
                  </v-icon>
                </template>
                <span>
                  Preço total para revenda = Preço <br />
                  por metro x comprimento x IPI
                </span>
              </v-tooltip>

              <v-text-field
                :disabled="isDetail"
                style="border: 1px solid #979797; border-radius: 7.5px"
                color="black"
                background-color="#F5F5F5"
                outlined
                :rules="[rules.required]"
                prefix="R$"
                hide-details
                :key="auxKey"
                v-model="currentProduct.clientPrice"
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="6" md="4" lg="3">
              <span class="ml-1 mb-2 label-details">
                Porcentagem Promocional:
              </span>

              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon class="pa-0" color="#DADADA" v-bind="attrs" v-on="on">
                    mdi-information-outline
                  </v-icon>
                </template>
                <span> Porcentagem promocional do card exibido no B2C </span>
              </v-tooltip>

              <v-text-field
                :disabled="isDetail"
                style="border: 1px solid #979797; border-radius: 7.5px"
                color="black"
                background-color="#F5F5F5"
                outlined
                suffix="%"
                hide-details
                v-model="currentProduct.percentage"
              ></v-text-field>
            </v-col>

            <v-col
              cols="12"
              sm="6"
              md="4"
              lg="3"
              v-if="currentProduct.percentage"
            >
              <span class="ml-1 mb-2 label-details">
                Data de inicio da promoção:
              </span>

              <v-text-field
                :disabled="isDetail"
                style="border: 1px solid #979797; border-radius: 7.5px"
                color="black"
                background-color="#F5F5F5"
                outlined
                type="date"
                hide-details
                v-model="currentProduct.promotionStart"
              ></v-text-field>
            </v-col>

            <v-col
              cols="12"
              sm="6"
              md="4"
              lg="3"
              v-if="currentProduct.percentage"
            >
              <span class="ml-1 mb-2 label-details">
                Data de fim da promoção:
              </span>

              <v-text-field
                :disabled="isDetail"
                style="border: 1px solid #979797; border-radius: 7.5px"
                color="black"
                background-color="#F5F5F5"
                outlined
                type="date"
                hide-details
                v-model="currentProduct.promotionEnd"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row class="ma-0">
            <v-col cols="12" sm="6" md="6" lg="3">
              <v-autocomplete
                :disabled="isDetail"
                v-model="currentProduct.productAttributesGroup"
                :items="productAttributesGroup"
                item-text="name"
                item-value="id"
                outlined
                hide-details
                @change="defineGroup()"
                style="border-radius: 7.5px"
                append-icon="mdi-chevron-down"
                clearable
                placeholder="Selecione o grupo de atributo"
                dark
                background-color="normalred"
              ></v-autocomplete>
            </v-col>

            <v-col cols="12" sm="6" md="6" lg="3">
              <v-btn
                :disabled="valid"
                outlined
                block
                height="56"
                @click="importAttributeGroup"
                style="border-radius: 7.5px"
              >
                <span class="import-field">Importar grupo de atributo</span>
              </v-btn>
            </v-col>

            <v-col
              cols="12"
              sm="6"
              md="6"
              lg="3"
              v-if="currentProduct.skus.length > 0"
            >
              <v-btn
                :disabled="isDetail"
                outlined
                block
                height="56"
                @click="addSku"
                style="border-radius: 7.5px"
              >
                <span class="import-field">Adicionar SKU</span>
              </v-btn>
            </v-col>
          </v-row>

          <v-row class="ma-0">
            <v-col cols="12">
              <div class="width100 mt-4" v-if="currentProduct.skus.length > 0">
                <div class="attributes-title px-6 py-2">Atributos</div>

                <v-row
                   align="end"
                  class="d-flex align-end"
                  v-for="(sku, idx) in currentProduct.skus"
                  :key="idx"
                >
                  <v-col cols="12">
                    <v-divider class="mt-3" color="#DADADA"></v-divider>
                  </v-col>

                  <v-col cols="6" sm="4" md="2" lg="1" class="d-flex justify-center mb-4">
                    <v-checkbox
                      :disabled="isDetail"
                      height="20"
                      width="20"
                      outlined
                      color="black"
                      v-model="sku.isActive"
                      hide-details
                      style="border-radius: 4px !important"
                      required
                    ></v-checkbox>
                  </v-col>

                  <v-col cols="6" sm="4" md="2" lg="2">
                    <span class="attribute-name"> SKU </span>
                    <v-text-field
                      :disabled="true"
                      outlined
                      v-model="sku.sku"
                      :rules="sku.isActive ? [(v) => !!v || 'Campo obrigatório'] : []"
                      style="border: 1px solid #979797; border-radius: 7.5px"
                      background-color="#F5F5F5"
                      hide-details
                      color="black"
                      :value="idx"
                      required
                    ></v-text-field>
                  </v-col>

                  <v-col
                    v-for="attribute in sku.attributes"
                    :key="attribute.id"
                    class="d-flex align-end"
                    cols="12"
                    sm="6"
                    md="2"
                    lg="2"
                  >
                    <v-menu
                      v-if="attribute.attribute.type === 'Cor'"
                      top
                      nudge-bottom="105"
                      nudge-left="16"
                      :close-on-content-click="false"
                      :disabled="true"
                    >
                      <template v-slot:activator="{ on }">
                        <div class="text-center mt-7 mr-5" style="width: 150px">
                          <div :style="switchStyle(attribute.hex)" v-on="on" />
                          <!--<span class="color-field">Adicionar cor</span>-->
                        </div>
                      </template>
                      <v-card class="ma-0">
                        <v-card-text class="pa-0">
                          <v-color-picker
                            v-model="attribute.hex"
                            flat
                            hide-canvas
                            hide-inputs
                            hide-sliders
                            mode="hexa"
                            show-swatches
                            swatches-max-height="130"
                          />
                        </v-card-text>
                      </v-card>
                    </v-menu>

                    <div>
                      <span class="attribute-name">
                        {{ attribute.attribute.name }}
                      </span>

                      <v-text-field
                        :disabled="!sku.added"
                        outlined
                        :rules="sku.isActive ? [(v) => !!v || 'Campo obrigatório'] : []"
                        v-model="attribute.name"
                        style="border: 1px solid #979797; border-radius: 7.5px"
                        color="black"
                        background-color="#F5F5F5"
                        hide-details
                        required
                      ></v-text-field>
                    </div>
                  </v-col>

                  <v-col cols="6" sm="4" md="2" lg="2">
                    <span class="attribute-name">Valor</span>
                    <v-text-field
                      :disabled="isDetail"
                      outlined
                      :rules="sku.isActive ? [(v) => !!v || 'Campo obrigatório'] : []"
                      v-model="sku.differentValue"
                      style="border: 1px solid #979797; border-radius: 7.5px"
                      background-color="#F5F5F5"
                      color="black"
                      prefix="R$"
                      hide-details
                      required
                    ></v-text-field>
                  </v-col>

                  <v-col cols="6" sm="4" md="2" lg="2">
                    <span class="attribute-name">Preço mínimo</span>
                    <v-text-field
                      :disabled="isDetail"
                      outlined
                      :rules="sku.isActive ? [(v) => !!v || 'Campo obrigatório'] : []"
                      v-model="sku.minimumPrice"
                      style="border: 1px solid #979797; border-radius: 7.5px"
                      background-color="#F5F5F5"
                      color="black"
                      prefix="R$"
                      hide-details
                      required
                    ></v-text-field>
                  </v-col>

                  <v-col cols="6" sm="4" md="2" lg="2">
                    <span class="attribute-name">Preço máximo</span>
                    <v-text-field
                        :disabled="isDetail"
                        outlined
                        :rules="sku.isActive ? [(v) => !!v || 'Campo obrigatório'] : []"
                        v-model="sku.maximumPrice"
                        style="border: 1px solid #979797; border-radius: 7.5px"
                        background-color="#F5F5F5"
                        color="black"
                        prefix="R$"
                        hide-details
                        required
                    ></v-text-field>
                  </v-col>

                  <v-col cols="6" sm="4" md="2" lg="2">
                    <span class="attribute-name">Estoque mínimo</span>
                    <v-text-field
                        :disabled="isDetail"
                        outlined
                        :rules="sku.isActive ? [(v) => !!v || 'Campo obrigatório'] : []"
                        v-model="sku.minimumStock"
                        style="border: 1px solid #979797; border-radius: 7.5px"
                        v-mask="'######'"
                        background-color="#F5F5F5"
                        color="black"
                        hide-details
                        required
                    ></v-text-field>
                  </v-col>

                  <v-col cols="6" sm="4" md="2" lg="1" class="d-flex justify-end mb-4">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          :disabled="isDetail"
                          outlined
                          fab
                          tile
                          style="border-radius: 6px"
                          height="35"
                          width="35"
                          class="table-button mt-5 mr-4 edit-button"
                          color="normalred"
                          @click="removeSku(sku)"
                          v-bind="attrs"
                          v-on="on"
                        >
                          <v-icon dark size="18">mdi-trash-can-outline</v-icon>
                        </v-btn>
                      </template>
                      <span>Remover</span>
                    </v-tooltip>
                  </v-col>
                </v-row>
              </div>
            </v-col>
          </v-row>

          <v-row v-if="!isDetail" class="ma-0" justify="center">
            <v-col cols="12" sm="6" md="4" lg="2" class="d-flex justify-center">
              <v-btn
                :disabled="isDetail"
                class="cancel-button"
                outlined
                height="50"
                style="border-radius: 10px"
                @click="back"
              >
                Cancelar
              </v-btn>
            </v-col>
            <v-col cols="12" sm="4" md="4" lg="4" class="d-flex justify-center">
              <v-btn
                :disabled="isDetail"
                class="primary-button d-flex justify-content-center"
                style="font-weight: bold !important; font-size: 16px !important"
                :loading="loading"
                @click="submit()"
                >{{ isEditing ? "Alterar Produto" : "Cadastrar Produto" }}
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-card>
    </v-container>

    <v-dialog v-model="deleteDialog" max-width="450px">
      <DeleteModal
        title="Deletar"
        textMessage="Tem certeza que deseja deletar este produto?"
        cancelBtn="Cancelar"
        okbtn="Deletar"
        textObservation=""
        icone="mdi-restore-alert"
        @close="deleteDialog = false"
        @action="(deleteDialog = false), removeProduct('/products')"
        @closeNoLoading="closeNoLoading"
        :key="dialogKey"
      />
    </v-dialog>

    <v-dialog v-model="sucessDialog" max-width="700px">
      <ConfirmModal
        title="Produto Cadastrado"
        textMessage="Você confirma esse cadastro?"
        okbtn="Sim, Confirmar"
        textObservation1="O novo produto será cadastrado e poderar ser alterado sempre que necessário."
        icone="mdi-restore-alert"
        @close="(sucessDialog = false), updateTable()"
        @action="submit(), (sucessDialog = false)"
        :loading="true"
      />
    </v-dialog>

    <v-dialog v-model="backDialog" max-width="650px">
      <ConfirmModal
        title="Atenção: Você confirma sua saída?"
        textMessage="Você confirma que quer voltar para página de produtos?"
        okbtn="Sim, quero sair"
        cancelBtn="Não"
        textObservation1="Se você confirmar as informações cadastradas até agora serão perdidas."
        icone="mdi-restore-alert"
        @close="backDialog = false"
        @action="back"
        :loading="true"
      />
    </v-dialog>

    <v-dialog
      transition="dialog-bottom-transition"
      v-model="newAttributeGroupDialog"
      max-width="950px"
    >
      <NewAttributeGroup
        :attributeGroup="currentAttributeGroup"
        v-if="newAttributeGroupDialog"
        @action="newAttributeGroupDialog = true"
        @close="close"
        @closeNoLoading="closeNoLoading"
        :key="dialogKey"
      />
    </v-dialog>

    <v-dialog
      transition="dialog-bottom-transition"
      v-model="newAttributeDialog"
      max-width="840px"
    >
      <NewAttribute
        :attribute="currentAttribute"
        :textMessage="'Selecione um tipo de atributo'"
        @action="newAttributeDialog = true"
        @close="close"
        @closeNoLoading="closeNoLoading"
        :key="dialogKey"
      />
    </v-dialog>

    <v-dialog
      transition="dialog-bottom-transition"
      v-model="newCategoryDialog"
      max-width="500px"
    >
      <NewCategory
        :category="currentCategory"
        @close="close"
        @closeNoLoading="closeNoLoading"
        :key="dialogKey"
      />
    </v-dialog>

    <v-dialog v-model="confirmExitDialog" max-width="480">
      <ConfirmExit
        title="Atenção"
        message="Você pode perder suas alterações, tem certeza de que deseja voltar?"
        buttonText="Confirmar"
        @cancel="confirmExitDialog = false"
        @action="$router.push('/products')"
      />
    </v-dialog>

    <v-dialog
      v-model="dialogDeleteImage"
      style="height: 300px !important"
      max-width="500px"
    >
      <ConfirmModal
        okbtn="Confirmar"
        textObservation1="Deseja realmente deletar essa imagem do produto?"
        icone="mdi-restore-alert"
        @close="dialogDeleteImage = false"
        cancelBtn="Cancelar"
        @action="deleteImage()"
        :loading="true"
      />
    </v-dialog>


    <v-dialog
      v-model="dialogvideo"
      max-width="800px"
    >
       <v-card>
         <v-card-title class="   " >
           <h3 class="pb-3">Adicionar vídeo</h3>
         </v-card-title>
         <v-divider></v-divider>
         <v-card-text>
           Cole o código HTML de incorporação (embed) do YouTube. Para obter esse código, abra o vídeo no YouTube, <br/>clique em ‘Compartilhar’, selecione ‘Incorporar’ e copie o código exibido.
         </v-card-text>

         <v-textarea
             outlined
             :rules="[rules.required]"
             hide-details
             placeholder="Cole o código de incorporação (embed) do YouTube aqui"
             style="border: 1px solid #979797; border-radius: 7.5px"
             color="black"
             background-color="#F5F5F5"
             class="mx-5"
             rows="3"
             v-model="embeddedVideo"
         ></v-textarea>

         <v-divider></v-divider>

         <v-card-actions>
           <v-spacer></v-spacer>
           <v-btn
               color="primary"
               text
               @click="dialogvideo = false"
           >
             Cancelar
           </v-btn>
           <v-btn
               color="green"
               text
               :disabled="!embeddedVideo"
               @click="addVdeo()"
           >
             Adicionar
           </v-btn>
         </v-card-actions>
       </v-card>
    </v-dialog>
  </div>
</template>

<style scoped>
.video-wrapper {
  position: relative;
  width: 100%;
  padding-bottom: 56.25%; /* 16:9 */
}

.video-wrapper iframe {
  width: 150px!important;
  height: 150px!important;
  top: 0;
  left: 0;
}
.delete-photo {
  cursor: pointer;
  font-weight: bold;
  text-transform: uppercase;
  font-size: 15px;
  line-height: 27px;
  letter-spacing: 0.15px;
  color: #bc0000;
}
.cancel-button {
  border-radius: 7.5px;
  transition: 0.3s;
}

.cancel-button:hover {
  color: white !important;
  background: #000000;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.2);
}

.cadaster-button {
  border-radius: 7.5px;
  transition: 0.3s;
  background: #bc0000 !important;
}

.cadaster-button:hover {
  color: white !important;
  background: #e8161e !important;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.2);
}

.main-card {
  display: flex;
  flex-direction: column;
  max-width: unset;
  background: #ffffff;
  box-shadow: 0px 7px 20px rgba(45, 48, 56, 0.1);
  border-radius: 6px;
}

.import-field {
  font-weight: bold;
  font-size: 14px;
}

.label-details {
  font-weight: 300;
  font-size: 15px;
  line-height: 18px;
  letter-spacing: 0.15px;
  color: #979797;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.div-images {
  padding-bottom: 5px;
  overflow-x: scroll;
}

.div-images::-webkit-scrollbar {
  background-color: #fff;
  height: 10px;
  border-radius: 3.5px;
}

.div-images::-webkit-scrollbar-thumb {
  background: #ccc;
  border-radius: 3.5px;
}

.photo-field {
  font-weight: 300;
  font-size: 15px;
  line-height: 18px;
  letter-spacing: 0.15px;
  color: #979797;
}

.image-container {
  cursor: pointer;
  transition: 0.1s;
  width: 150px;
  height: 150px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #f5f5f5;
  border: 1px dashed #dadada;
  box-sizing: border-box;
  border-radius: 10px !important;
}

.main-image-field {
  font-weight: bold;
  font-size: 11px;
  line-height: 13px;
  text-align: center;
  letter-spacing: 0.15px;
  color: #e30011;
}

.image-field {
  font-weight: 300;
  font-size: 11px;
  line-height: 13px;
  letter-spacing: 0.15px;
  color: #979797;
}

.color-field {
  font-weight: 300;
  font-size: 11px;
  line-height: 13px;
  letter-spacing: 0.15px;
  color: #979797;
}

.attribute-name {
  font-style: normal;
  font-weight: 300;
  font-size: 15px;
  line-height: 18px;
  letter-spacing: 0.15px;
  color: #979797;
}

.attributes-title {
  background: #f5f5f5;
  border-radius: 4px;
  font-size: 18px;
  letter-spacing: 0.15px;
  color: rgba(45, 48, 56, 0.5);
  width: 100%;
  font-weight: bold;
}

.select-red {
  background-color: #bc0000 !important;
  border-radius: 8px;
}

.cssTable,
.width100 {
  width: 100%;
}

.skuTableHeader {
  background-color: #f1f2f2;
}

.skuTableHeaderText {
  font-weight: bold;
  color: black;
  font-size: 1.2rem;
}

.titulo-detail {
  color: black;
  font-family: Roboto;
  font-style: normal;
  font-size: 20px;
  line-height: 40px;
  font-weight: bold;
}
.titulo-detail-2 {
  color: black;
  font-family: Roboto;
  font-style: normal;
  font-size: 16px;
  line-height: 40px;
  font-weight: bold;
}
.titulo-detail-3 {
  color: red;
  font-family: Roboto;
  font-style: normal;
  font-size: 14px;
  line-height: 40px;
  justify-content: end;
}
p {
  font-weight: bold;
}

.flex-end {
  justify-content: flex-end;
}

.space-between {
  justify-content: space-between;
}
.black--text /deep/ label {
  color: black;
  font-size: 15px;
}

.item {
  background: #424242 !important;
}

.item span {
  font-size: 1.05rem;
  color: #fff;
}

.back {
  background: #e9e9e9 !important;
  max-width: unset;
}

.filterAutocomplete {
  box-sizing: border-box !important;
  border-radius: 10px !important;
  width: 100% !important;
}

.table-button {
  font-weight: bold !important;
  transition: 300ms !important;
  border: 2px solid #bc0000;
  box-sizing: border-box;
  border-radius: 4px;
}

.table-button:hover {
  background: #2d3038 !important ;
  color: white !important;
}

.table-button:focus {
  background: #444854;
  color: white !important;
}

.mytable .v-table tbody tr {
  border-left: 5px solid red !important;
}

@media (max-width: 330px) {
  .v-menu__content {
    left: 15px !important;
    max-width: unset;
  }
}

@media (max-width: 860px) {
  .table-header {
    display: none;
  }
}

@media screen and (max-width: 700px) {
  .theme--light.v-data-table thead tr:last-child th,
  .theme--light.v-data-table tbody tr:not(:last-child) td:last-child,
  .theme--light.v-data-table tbody tr td,
  .theme--light.v-data-table
    tbody
    tr:not(:last-child)
    td:not(.v-data-table__mobile-row) {
    border-bottom: medium solid black !important;
  }
}

.config {
  font-weight: bold;
  background-color: #ffffff !important;
  border: 1px solid #bc0000 !important;
  box-sizing: border-box;
  border-radius: 10px;
  height: 50px;
}

.cssTable {
  text-align: center;
  vertical-align: middle;
  border-spacing: 0px;
}

.linha-end {
  justify-content: flex-end;
}
.linha-top {
  justify-content: flex-start;
  align-items: flex-end;
}

.btns-down {
  text-align: -webkit-center;
}

.dividers {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #f1f2f2;
  font-weight: bold;
}

.row-down {
  justify-content: space-evenly;
}

.label {
  font-family: Roboto;
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 22px;
  text-align: center;
  letter-spacing: 0.2px;
  color: #232021;
}
</style>

<script>
import ApiService from "../../../../services/ApiService";
import HeaderProduct from "../components/HeaderProduct/HeaderProduct.vue";
import Vue from "vue";
import ConfirmModal from "../../components/ConfirmModal.vue";
import { VMoney } from "v-money";
import NewAttribute from "../ProductsConfig/components/newAttribute.vue";
import NewCategory from "../ProductsConfig/components/newCategory.vue";
import NewAttributeGroup from "../ProductsConfig/components/newAttributeGroup.vue";
import ConfirmExit from "../../components/ConfirmExit.vue";
import DeleteModal from "../../components/DeleteModal.vue";
import draggable from 'vuedraggable'
export default {
  name: "Register",

  components: {
    HeaderProduct,
    ConfirmModal,
    NewAttribute,
    NewCategory,
    NewAttributeGroup,
    ConfirmExit,
    DeleteModal,
    draggable,
  },
  computed: {
    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost"
      };
    },
    dragOptionsVideos() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost"
      };
    }
  },
  async mounted() {
    this.loading = true;

    await this.updateList();

    if (this.$route.query.isDetail != null) {
      this.isDetail = true;
    }

    if (this.$route.query.id) {
      this.isEditing = true;

      await this.apiService
        .get(`product/get-one/admin?id=` + this.$route.query.id)
        .then((response) => {
          this.currentProduct = { ...response };
          this.currentProduct.productInventory++;
          this.currentProduct.images.forEach((image, index) => {
            if(!image.sort) {
              image.sort = index + 1
            }
          })

          this.currentProduct.videos.forEach((video, index) => {
            if(!video.sort) {
              video.sort = index + 1
            }
            video.uid = crypto.randomUUID()
          })
          console.log(this.currentProduct.videos)

          this.currentProduct.skus.map((x) => {
            x.differentValue = x.differentValue.toFixed(2);
            x.maximumPrice = x.maximumPrice.toFixed(2);
            x.minimumPrice = x.minimumPrice.toFixed(2);
            x.minimumStock = x.minimumStock && x.minimumStock > 0 ? x.minimumStock : 10;
          });

          this.currentProduct.productCategories = [];

          for (let i = 0; i < response.categories.length; i++) {
            const findCurrentCategory = this.productCategories.find(
              (x) => x.categoryId === response.categories[i].categoryId
            );
            this.currentProduct.productCategories.push(findCurrentCategory);
          }

          if (this.currentProduct.productCategories.length > 0) {
            this.listSubCategorias();
          }

          this.currentProduct.price = response.price.toFixed(2);
          this.currentProduct.productSubCategoriesAux = response.subCategories;
          this.currentProduct.ipi = response.ipi.toFixed(2);
          this.currentProduct.clientPrice = response.clientPrice.toFixed(2);
          this.currentProduct.promotionStart =
            response.promotionStart.split("T")[0];
          this.currentProduct.promotionEnd =
            response.promotionEnd.split("T")[0];

          this.currentProduct.finalPrice = response.finalPrice.toFixed(2);
          this.currentProduct.espessura = response.espessura.toFixed(2);
          this.currentProduct.comprimento = response.comprimento.toFixed(2);
          this.currentProduct.pesoLiquido = response.pesoLiquido.toFixed(2);
          this.currentProduct.largura = response.largura.toFixed(2);

          this.auxKey = !this.auxKey;
          this.auxKeyMetro = !this.auxKeyMetro;

          this.colorToFirst();
          this.validateSkuImport();
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
        });
    }

    this.loading = false;
    await this.validateSkuImport();
    if (this.isDetail) {
      this.valid = false;
    }
  },

  data: () => ({
    dialogvideo: false,
    drag: false,
    dragVideo: false,
    valid: true,
    imageHasToBeDeleted: "",
    auxKeyMetro: false,
    auxKey: false,
    searchCategoryInput: "",
    searchSubCategoryInput: "",
    deleteDialog: false,
    isDetail: false,
    currentCategory: {},
    confirmExitDialog: false,
    removedSkus: [],
    menu: false,
    defineCard: false,
    backDialog: false,
    checkbox: true,
    fileRecords: [],
    checkKey: "",
    newAttributeDialog: false,
    newAttributeGroupDialog: false,
    newCategoryDialog: false,
    dialogKey: false,
    currentAttributeId: 0,
    currentAttribute: {},
    pickerColor: "",
    currentAttributeGroup: {},
    componentKey: false,
    importedNewAttributeGroup: false,
    filter: {
      page: 1,
      pageSize: 15,
      CategoryName: null,
      CategoryCode: null,
      CategoryInventory: null,
      CategoryId: null,
      Name: null,
      Type: null,
      Id: null,
    },
    isEditing: false,
    productCategories: [],
    productSubCategories: [],
    productAttributes: [],
    productAttributesGroup: [],
    chips: [],
    clear: false,
    dialog: false,
    loading: false,
    sucessDialog: false,
    dialogDeleteImage: false,
    postalCode: "",
    agreement: false,
    firstValid: true,
    closeNoLoading: false,
    apiService: new ApiService(),

    status: [
      { label: "Em estoque", value: 1 },
      { label: "Fora de estoque", value: 2 },
    ],
    statusCalculator: [
      { label: "Sim", value: true },
      { label: "Não", value: false },
    ],
    currentProduct: {
      percentage: 0,
      promotionStart: null,
      promotionEnd: null,
      productDescription: "",
      productName: "",
      agreement: false,
      addedAttributes: [],
      productCategory: "",
      images: [],
      videos: [],
      productCategories: [],
      productSubCategories: [],
      productSubCategoriesAux: [],
      skus: [],
      ipi: "",
      price: "",
      espessura: "",
      largura: "",
      comprimento: "",
      pesoLiquido: "",
    },
    embeddedVideo: null,
    showVideos: true,
    rules: {
      nameRules: (v) => (v && v.length <= 255) || "Máximo de 255 caracteres",
      max32Caracteres: (v) =>
        (v && v.length <= 32) || "Máximo de 32 caracteres",
      max64Caracteres: (v) =>
        (v && v.length <= 64) || "Máximo de 64 caracteres",

      required: (value) => !!value || "Campo requerido.",

      min: (v) => v.length >= 4 || "Minimo de 4 caracteres.",
    },

    money: {
      decimal: ",",
      thousands: ".",
      precision: 2,
      masked: false,
    },
  }),

  directives: { money: VMoney },

  methods: {
    async validateSkuImport() {
      this.apiService
        .post(
          "ResaleProductSku/validate",
          this.currentProduct.skus.map((x) => x.id)
        )
        .then((response) => {
          this.valid = response.content;
        });
    },

    async listSubCategorias() {
      let IdList = [];
      this.currentProduct.productCategories.forEach((x) => {
        IdList.push({ Id: x.categoryId });
      });

      const SubCategoryIdFind = {
        IdList: IdList,
      };
      await this.apiService
        .post(`category/subCategoryIdFind`, SubCategoryIdFind)
        .then((response) => {
          this.productSubCategories = response.content;
          let productSubCategoriesAux = [];
          for (
            let i = 0;
            i < this.currentProduct.productSubCategoriesAux.length;
            i++
          ) {
            const findCurrentSubCategory = this.productSubCategories.find(
              (x) =>
                x.subCategoryId ===
                this.currentProduct.productSubCategoriesAux[i].subCategoryId
            );
            productSubCategoriesAux.push(findCurrentSubCategory);
          }

          this.currentProduct.productSubCategories = productSubCategoriesAux;
        })
        .catch((err) => {
          Vue.$globalEvent.$emit("onFlashMessage", {
            type: "error",
            title: "Erro listar produtos",
            message: err.body.message,
            trace: null,
          });
          this.loading = false;
        });
    },

    deleteProduct() {
      this.deleteDialog = true;
    },

    async removeProduct(route) {
      this.loading = true;
      await this.apiService
        .delete(`product/delete`, this.currentProduct)
        .then(() => {
          this.loading = false;
          this.deleteDialog = false;
          this.$router.push(route);
        })
        .catch((erro) => {
          this.loading = false;
          this.deleteDialog = false;
        });
    },

    showPhoto(image) {
      if (image.includes("Uploads/")) {
        var env_url = process.env.VUE_APP_BASE_URL;
        return env_url + image;
      } else {
        return image;
      }
    },

    defineGroup() {
      this.defineCard = true;
    },

    openPicker() {
      document.querySelector("#imageInput").click();
    },
    addVdeo() {
      try {
        if(!this.currentProduct.videos){
          this.currentProduct.videos = []
        }
        this.embeddedVideo = this.embeddedVideo
            .replace(/width="\d+"/, 'width="140"')
            .replace(/height="\d+"/, 'height="140"');
        this.currentProduct.videos.push(
          {
            htmlEmbed: this.embeddedVideo,
            uid: crypto.randomUUID(),
          }
        )
        this.embeddedVideo = null
        this.dialogvideo = false
        this.dialogvideo = true
        this.dialogvideo = false
      } catch (e) {
        console.log(e)
      }
    },
    showModalAddVideos() {
      this.embeddedVideo = null
      this.dialogvideo = true
    },

    deleteVideo(uid) {
      try {
        this.showVideos = false
        this.currentProduct.videos = this.currentProduct.videos.filter(v => v.uid !== uid)
        this.showVideos = true
        console.log(this.currentProduct.videos)
      } catch (e) {
        console.log(e)
      }
    },

    confirmDeleteImage(image) {
      this.imageHasToBeDeleted = image;
      this.dialogDeleteImage = true;
    },

    moveImageToFirst(image) {
      if (this.currentProduct.images.indexOf(image) > 0) {
        const index = this.currentProduct.images.indexOf(image);
        this.currentProduct.images.splice(index, 1);
        this.currentProduct.images.unshift(image);
      }
    },

    async deleteImage() {
      if(!this.imageHasToBeDeleted.path.includes('Uploads/Products/')){
        const index = this.currentProduct.images.indexOf(
            this.imageHasToBeDeleted
        );
        this.currentProduct.images.splice(index, 1);
        this.loading = false;
        this.deleteDialog = false;
        this.dialogDeleteImage = false;
        return
      }
      await this.apiService
        .delete(`product/deleteImageProduct`, this.imageHasToBeDeleted)
        .then((response) => {
          Vue.$globalEvent.$emit("onFlashMessage", {
            type: "success",
            title: "",
            message: response.message,
            trace: null,
          });
          const index = this.currentProduct.images.indexOf(
            this.imageHasToBeDeleted
          );
          this.currentProduct.images.splice(index, 1);
        })
        .catch((erro) => {
          Vue.$globalEvent.$emit("onFlashMessage", {
            type: "error",
            title: "",
            message: "Não foi possível excluir a imagem",
            trace: null,
          });
          this.loading = false;
          this.deleteDialog = false;
        });
      this.dialogDeleteImage = false;
    },

    setImages(images) {
      let sizeErrors = 0;
      for (let i = 0; i < images.length; i++) {
        if (images[i].size < 2097152) {
          this.iconFile = images[i];
          const reader = new FileReader();
          reader.readAsDataURL(images[i]);
          reader.onload = () => {
            this.currentProduct.images.push({
              path: reader.result,
            });
          };
        } else {
          Vue.$globalEvent.$emit("onFlashMessage", {
            type: "error",
            title: "",
            message: `A imagem '${images[i].name}' pode no máximo de 2MB!`,
            trace: null,
          });
        }
      }
    },

    switchStyle(color, menu) {
      return {
        border: "2px dashed #DADADA",
        boxSizing: "border-box",
        backgroundColor: color,
        cursor: "pointer",
        height: "52px",
        width: "56px",
        margin: "0 auto 0 auto",
        borderRadius: menu ? "50%" : "10px",
        transition: "border-radius 200ms ease-in-out",
      };
    },

    async importAttributeGroup() {
      let attributeGroup = this.productAttributesGroup.find(
        (x) => x.id == this.currentProduct.productAttributesGroup
      );
      this.importedNewAttributeGroup = true;
      let formatedAttributes = [];

      if (attributeGroup != null) {
        attributeGroup.attributeGroupAttributes.forEach((x) => {
          let model = [];
          x.attributeGroupItems.forEach((y) => {
            model.push({
              attribute: x.attribute,
              attributeId: x.attribute.id,
              name: y.name,
              hex: y.hex,
              id: y.id,
              attributeGroupAttributeId: y.attributeGroupAttributeId,
            });
          });
          formatedAttributes.push(model);
        });

        let arr = formatedAttributes.reduce((a, b) =>
          a.reduce((r, v) => r.concat(b.map((w) => [].concat(v, w))), [])
        );

        let results = [];

        arr.map((x, idx) => {
          let model = {};
          model.isActive = true;
          model.sku = idx;
          model.attributes = [];
          if (Array.isArray(x)) {
            x.map((y) => {
              model.attributes.push(y);
            });
          } else {
            model.attributes.push(x);
          }
          results.push(model);
        });

        this.currentProduct.skus = [];

        results.forEach((z) => {
          const attributes = [];

          z.attributes.forEach((attr) => {
            attributes.push({ ...attr });
          });

          this.currentProduct.skus.push({
            sku: z.sku + 1,
            isActive: z.isActive,
            attributes,
          });
        });

        this.colorToFirst();

        this.$forceUpdate();
      }
    },

    colorToFirst() {
      this.currentProduct.skus.map((sku) => {
        let findColor = [];

        sku.quantity = 0;

        findColor = sku.attributes.filter((x) => x.attribute.type === "Cor");

        if (findColor.length > 0) {
          findColor.map((color) => {
            let idx = sku.attributes.findIndex((y) => y == color);
            sku.attributes.splice(0, 0, sku.attributes.splice(idx, 1)[0]);
          });
        }
      });
    },

    addAttribute() {
      let attribute = this.productAttributes.find(
        (x) => x.id == this.currentAttributeId
      );

      if (attribute != null) {
        let error = false;
        for (let i = 0; i < this.currentProduct.skus.length; i++) {
          this.currentProduct.skus[i].attributes.forEach((attr) => {
            if (attr.attributeId == this.currentAttributeId) {
              error = true;
            }
          });

          if (!error) {
            this.currentProduct.skus[i].attributes.push({
              attributeId: this.currentAttributeId,
              attribute: attribute,
              hex: "",
            });
          }
        }

        if (error) {
          this.$toast.warn("Atributo já incluso");
        }

        this.currentAttributeId = 0;
      }
    },

    calculateClientPrice() {
      const ipiF =
        1 + parseFloat(this.currentProduct.ipi.replace(",", ".")) / 100;
      const mount = parseFloat(
        this.currentProduct.price.replace(".", "").replace(",", ".")
      );
      if (this.currentProduct.ipi == "") {
        this.currentProduct.clientPrice = this.currentProduct.price;
      } else {
        this.currentProduct.clientPrice = (mount * ipiF).toFixed(2);
      }

      this.auxKey = !this.auxKey;
    },

    skuDefault(value) {
      this.currentProduct.productSku = "SKU-" + value;
      this.componentKey += 1;
    },

    addSku() {
      let sku = { ...this.currentProduct.skus[0] };
      sku.sku = this.currentProduct.skus.length + 1;
      sku.added = true;
      sku.id = 0;
      sku.differentValue = 0;
      sku.maximumPrice = 0;
      sku.minimumPrice = 0;
      sku.attributes = [];
      this.currentProduct.skus[0].attributes.forEach((attr) => {
        sku.attributes.push({
          attribute: attr.attribute,
          hex: "",
          name: "",
          attributeId: attr.attribute.id,
        });
      });

      this.currentProduct.skus.push(sku);
    },

    removeSku(sku) {
      this.removedSkus.push(sku);
      this.currentProduct.skus = this.currentProduct.skus.filter(
        (x) => x != sku
      );
    },

    checking() {
      this.checkKey += 1;
    },

    async updateList() {
      this.loading = true;

      await this.apiService
        .get(`category/list`)
        .then((response) => {
          this.productCategories = response;
        })
        .catch((err) => {
          Vue.$globalEvent.$emit("onFlashMessage", {
            type: "error",
            title: "Erro listar produtos",
            message: err.body.message,
            trace: null,
          });

          this.loading = false;
        });

      await this.apiService.get(`attribute/list`).then((response) => {
        this.productAttributes = response;
      });

      await this.apiService.get(`attributesgroup/list`).then((response) => {
        this.productAttributesGroup = response;
      });

      this.loading = false;
      this.componentKey += 1;
    },

    async remove(item, obj, listSubCategorias) {
      obj.splice(this.chips.indexOf(item), 1);
      obj = [...this.chips];

      if (listSubCategorias) {
        await this.listSubCategorias();
      }
    },

    back() {
      this.confirmExitDialog = true;
    },

    async validate() {
      this.loading = true;
      const userValid = {
        SKU: this.currentProduct.productSku,
        EAN: this.currentProduct.productEAN,
      };

      await this.apiService
        .post("product/validate", userValid)
        .then((resp) => {
          Vue.$globalEvent.$emit("onFlashMessage", {
            type: "error",
            title: resp.body.message,
            message: "Produto validado com sucesso.",
            trace: null,
          });
        })
        .catch((err) => {
          Vue.$globalEvent.$emit("onFlashMessage", {
            type: "error",
            title: err.body.message,
            message: "Erro na validação do formulário de produtos.",
            trace: null,
          });
        });
      this.loading = false;
    },

    changeName(item) {
      if (item.hex) {
        item.hex = item.hex;
      } else {
        item.name = item.name;
      }
    },

    changeStyle(color) {
      const { pickerColor, textMenu } = this;
      return {
        backgroundColor: color,
        cursor: "pointer",
        height: "30px",
        marginBottom: "5px",
        width: "30px",
        borderRadius: textMenu ? "50%" : "4px",
        borderStyle: "double",
        transition: "border-radius 200ms ease-in-out",
      };
    },

    generatePassword() {
      return Math.random().toString(36).slice(-8);
    },

    close() {
      this.confirmExitDialog = false;
      this.newAttributeDialog = false;
      this.newAttributeGroupDialog = false;
      this.newCategoryDialog = false;
      this.updateList();
    },

    async submit() {
      this.loading = true;
      if (this.$refs.form.validate()) {
        if (this.currentProduct.images.length === 0) {
          this.$toast.error("Nenhuma imagem foi selecionada");
          this.loading = false;
          return;
        }

        if (this.currentProduct.skus.length < 1) {
          this.$toast.error("É necessario cadastro de atributos ativos");
          this.loading = false;
          return;
        }

        let price = parseFloat(
          this.currentProduct.price.replace(".", "").replace(",", ".")
        );

        let clientPrice = parseFloat(
          this.currentProduct.clientPrice.replace(".", "").replace(",", ".")
        );

        /*let finalPrice = parseFloat(
          this.currentProduct.finalPrice.replace(".", "").replace(",", ".")
        );*/
        this.currentProduct.images.forEach((image, index) => {
          image.sort = index + 1
        })
        this.currentProduct.videos.forEach((video, index) => {
          video.sort = index + 1
        })
        if (
          price === 0 ||
          price == null ||
          clientPrice === 0 ||
          clientPrice == null ||
          !this.currentProduct.comprimento ||
          !this.currentProduct.pesoLiquido ||
          !this.currentProduct.largura ||
          !this.currentProduct.espessura ||
          this.currentProduct.comprimento === 0 ||
          this.currentProduct.comprimento == null ||
          this.currentProduct.largura === 0 ||
          this.currentProduct.largura == null ||
          this.currentProduct.pesoLiquido === 0 ||
          this.currentProduct.pesoLiquido == null ||
          this.currentProduct.espessura === 0 ||
          this.currentProduct.espessura == null
        ) {
          Vue.$globalEvent.$emit("onFlashMessage", {
            type: "error",
            title: "",
            message: "Preencha os campos de preço corretamente",
            trace: null,
          });

          this.loading = false;
          return;
        }
        let model = {
          Espessura: this.currentProduct.espessura.toString().replace(",", "."),
          Comprimento: this.currentProduct.comprimento.toString().replace(",", "."),
          Largura: this.currentProduct.largura.toString().replace(",", "."),
          PesoLiquido: this.currentProduct.pesoLiquido.toString().replace(",", "."),
          ProductId: this.currentProduct.productId,
          ProductName: this.currentProduct.productName,
          ProductCode: this.currentProduct.productCode,
          ProductInventory: this.currentProduct.productInventory - 1,
          ProductSKU: this.currentProduct.productSku,
          ProductEAN: this.currentProduct.productEAN,
          ProductSubcategory: this.currentProduct.productSubcategory,
          Calculator: this.currentProduct.calculator,
          Categories: [],
          SubCategories: [],
          ProductApplication: this.currentProduct.productApplication,
          ProductType: this.currentProduct.productType,
          ProductGlue: this.currentProduct.productGlue,
          ProductLiner: this.currentProduct.productLiner,
          ProductDurability: this.currentProduct.productDurability,
          ProductDescription: this.currentProduct.productDescription,
          ProductIndicator: this.currentProduct.productIndicator,
          Price: parseFloat(
            this.currentProduct.price.replace(",", ".")
          ),
          IPI:
            this.currentProduct.ipi != ""
              ? parseFloat(this.currentProduct.ipi)
              : 0,
          ClientPrice: parseFloat(
            this.currentProduct.clientPrice.replace(",", ".")
          ),
          /*FinalPrice: parseFloat(
            this.currentProduct.finalPrice.replace(".", "").replace(",", ".")
          ),*/
          ProductAttribute: this.currentProduct.productAttribute,
          StockUnit: this.currentProduct.stockunit,
          images: this.currentProduct.images,
          videos: this.currentProduct.videos,
          percentage: this.currentProduct.percentage,
          Skus: this.currentProduct.skus.map((x) => {
            x.differentValue = Number(x.differentValue.replace(",", ".")).toFixed(2);
            x.maximumPrice = Number(x.maximumPrice.replace(",", ".")).toFixed(2);
            x.minimumPrice = Number(x.minimumPrice.replace(",", ".")).toFixed(2);
            x.minimumStock = x.minimumStock && x.minimumStock > 0 ? Number(x.minimumStock) : 10;
            return x;
          }),
          promotionStart: this.currentProduct.promotionStart,
          promotionEnd: this.currentProduct.promotionEnd,
        };
        if (this.currentProduct.productCategories) {
          for (
            var i = 0;
            i < this.currentProduct.productCategories.length;
            i++
          ) {
            model.Categories.push({
              CategoryId: this.currentProduct.productCategories[i].categoryId,
            });
          }
        }

        if (this.currentProduct.productSubCategories) {
          this.currentProduct.productSubCategories.forEach((x) => {
            if (x) {
              model.SubCategories.push({
                SubCategoryId: x.subCategoryId,
              });
            }
          });
          /* for (var i = 0; i < this.currentProduct.productSubCategories.length; i++) {
            model.SubCategories.push({
              SubCategoryId: this.currentProduct.productSubCategories[i].subCategoryId,
            });
          }*/
        }

        let url = "product/add";
        if (this.isEditing) {
          url = "product/edit";
          model = {
            Product: model,
            RemovedSkus: this.removedSkus,
            ImportedNewAttributeGroup: this.importedNewAttributeGroup,
          };
        }

        await this.apiService
          .post(url, model)
          .then((resp) => {
            let token = localStorage.getItem("token");
            if (token) {
              this.$router.push("/products");
            } else {
              this.$router.push("/auth");
            }
            Vue.$globalEvent.$emit("onFlashMessage", {
              type: "success",
              title: resp.message,
              message: resp.message,
              trace: null,
            });

            this.loading = false;
          })
          .catch((err) => {
            Vue.$globalEvent.$emit("onFlashMessage", {
              type: "error",
              title: "Erro ao cadastrar produto",
              message: err.body.message,
              trace: null,
            });

            this.loading = false;
          });
      } else {
        Vue.$globalEvent.$emit("onFlashMessage", {
          type: "error",
          title: "Erro ao cadastrar produto",
          message: "Preencha os campos corretamente",
          trace: null,
        });
        this.loading = false;
      }
    },
  },
};
</script>
